/*接口URL管理*/
module.exports = {
    getAllUsersUrl: '/users/getAllUsers',//获取人员列表
    createUserUrl: '/users/createUser',//新增人员
    editUsersUrl: '/users/updateUser',//编辑人员
    delUsersUrl: '/users/deleteUser',//删除人员
    sendQiYeEmailUrl: '/users/sendQiYeEmail'//发送邮件
}
